import bannerImg from '../../assets/img/Aurus/banner/banner.jpg';


const AurusBanner = () => {
  return (
    <section className="bp-banner">
      <div className="wrapper">
        <h2 className="bp-header-h2">
          ПРИВНЕСИТЕ КРАСОТУ AURUS В СВОЙ ДОМ
        </h2>

        <div className="bp-banner__description">
          Климатическая техника премиум-класса AURUS - эталон инноваций, <br />
          эффективности и надежности. Эксклюзивные технологии, применяемые <br />
          в устройствах AURUS, мотивируют к новой философии жизни. <br />
          Это философия чистой эстетики, неиссякаемой энергии и неизменной гармонии.
        </div>

        <div className="bp-banner__block">
          <img
            src={bannerImg} 
            alt="Aurus banner"
            className="bp-banner__img"
          />
        </div>
      </div>
    </section>
  );
};

export default AurusBanner;
